'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalloutBanner;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Title = require('../typography/Title');

var _Title2 = _interopRequireDefault(_Title);

var _BodyText = require('../typography/BodyText');

var _BodyText2 = _interopRequireDefault(_BodyText);

require('./calloutBanner.scss');

require('../../styles/scss/global.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function CalloutBanner(props) {
  var title = props.title,
      bodyText = props.bodyText,
      type = props.type,
      footer = props.footer;
  var footerAction = footer || '';
  return _react2.default.createElement('div', {
    className: 'calloutBanner ' + type
  }, _react2.default.createElement(_Title2.default, {
    text: title
  }), _react2.default.createElement(_BodyText2.default, null, bodyText), footerAction);
}

CalloutBanner.propTypes = {
  title: _propTypes2.default.string.isRequired,
  bodyText: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.oneOf(['secondary', 'success', 'primary', 'info', 'warning', 'danger', 'dark', 'light']),
  footer: _propTypes2.default.node
};
CalloutBanner.defaultProps = {
  type: 'info',
  footer: ''
};